import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import AdminHeader from "./AdminHeader";
import Footer from "./Footer";

export default function AppLayout() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Header />
      <Box component="main" className="mt-[65px] flex flex-col flex-1">
      <AdminHeader />
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
}
